import {TransformBase} from "../TranformBase";

import {AssistantExternalWebhookCompactModel} from "@/api/models/assistants/externalWebhooks";
import {Assistant} from "@/api/services";

export class AssistantExternalWebhookTransform extends TransformBase {
  // TODO(future): use function overloading for other DTO inputs.
  public makeCompactModel(
    dto: Assistant,
  ): AssistantExternalWebhookCompactModel {
    const model: AssistantExternalWebhookCompactModel = {
      url: dto.external_webhook_url,
      createdAt: dto.external_webhook_creation_date,
    };

    return model;
  }
}

export const assistantExternalWebhookTransform =
  new AssistantExternalWebhookTransform();
